import { usePrefetchQuery, useQuery } from "@tanstack/react-query";
import { GetHeadToHeadPlayerStatsTabQuery } from "@/graphql/gql/graphql";
import { getHeadToHeadPlayerStats } from "../api";

const getQueryKey = (numberFireGameId: number) => [
  "headToHeadPlayerStats",
  numberFireGameId,
];

const useGetHeadToHeadPlayerStats = (numberFireGameId: number) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: getQueryKey(numberFireGameId),
    queryFn: () => getHeadToHeadPlayerStats(numberFireGameId),
    retry: false,
    select: (response: GetHeadToHeadPlayerStatsTabQuery) => ({
      event: response.event,
      ctp_nfl: response.ctp_Nfl,
    }),
  });

  return { data, isLoading, isError, refetch };
};

export const usePrefetchHeadToHeadPlayerStats = (numberFireGameId: number) => {
  usePrefetchQuery({
    queryKey: getQueryKey(numberFireGameId),
    queryFn: () => getHeadToHeadPlayerStats(numberFireGameId),
    retry: false,
  });
};

export default useGetHeadToHeadPlayerStats;
